var map = {
	"./blackGold/login_register/supps-icon.png": 25521,
	"./brownGold/login_register/supps-icon.png": 30572,
	"./darkBlue/login_register/supps-icon.png": 56961,
	"./greenYellow/login_register/supps-icon.png": 62609,
	"./redGold/login_register/supps-icon.png": 72885,
	"./skyBlue/login_register/supps-icon.png": 21423,
	"./whiteGold/login_register/supps-icon.png": 63089,
	"./yellowWhite/login_register/supps-icon.png": 98797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57234;